import type { QuizAnswerValue } from "@/types/api.types";
import { toMetricWeightKg } from "@/utils/conversion";

export const unitLabelMap: Record<string, string> = {
  metric: "kg",
  imperial: "lb",
};

export const formatWeight = (v?: QuizAnswerValue): string => {
  if (!v) return "—";

  if (typeof v === "object" && v && "value" in v && "unit" in v) {
    const unit = unitLabelMap[v.unit as string] ?? v.unit;
    return `${v.value} ${unit}`.trim();
  }
  return String(v);
};

export const getWeightKg = (v?: QuizAnswerValue): number | null => {
  if (!v) return null;

  if (typeof v === "object" && v && "value" in v && "unit" in v) {
    return toMetricWeightKg(String(v.value), v.unit as "metric" | "imperial");
  }
  return null;
};

export const calculateMonths = (diffKg: number): number => {
  if (diffKg <= 10) return 2;
  if (diffKg <= 20) return 4;
  if (diffKg <= 30) return 6;
  return 9;
};
